<div class="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6">
  <div class="mb-6">
    <h1 class="text-2xl font-bold text-gray-900">Machine owner onboarding</h1>
    <p class="text-sm text-gray-600">Register the legal owner (principal, vendor, subcontractor, or rental company), then pick them when adding a machine.</p>
  </div>

  <form [formGroup]="form" (ngSubmit)="save()" class="mb-8 grid grid-cols-1 gap-3 rounded-2xl border border-gray-200 bg-white p-6 shadow-sm md:grid-cols-3">
    <mat-form-field appearance="outline">
      <mat-label>Owner name</mat-label>
      <input matInput formControlName="owner_name" required />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Owner type</mat-label>
      <mat-select formControlName="owner_type">
        <mat-option *ngFor="let t of ownerTypes" [value]="t">{{ t }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Phone</mat-label>
      <input matInput formControlName="contact_phone" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <input matInput formControlName="contact_email" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>GST</mat-label>
      <input matInput formControlName="gst_number" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>PAN</mat-label>
      <input matInput formControlName="pan_number" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="md:col-span-2">
      <mat-label>Address</mat-label>
      <input matInput formControlName="address" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Linked vendor (optional)</mat-label>
      <mat-select formControlName="vendor_company_id">
        <mat-option value="">None</mat-option>
        <mat-option *ngFor="let v of vendors" [value]="v.id">{{ v.company_name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="md:col-span-3 flex gap-2">
      <button mat-raised-button color="primary" type="submit" [disabled]="saving">{{ editingId ? 'Update owner' : 'Onboard owner' }}</button>
      <button mat-stroked-button type="button" *ngIf="editingId" (click)="reset()">Cancel</button>
    </div>
  </form>

  <div class="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
    <table class="min-w-full text-sm">
      <thead class="bg-gray-50 text-left text-gray-600">
        <tr>
          <th class="px-4 py-3">Code</th>
          <th class="px-4 py-3">Name</th>
          <th class="px-4 py-3">Type</th>
          <th class="px-4 py-3">Contact</th>
          <th class="px-4 py-3">Vendor</th>
          <th class="px-4 py-3">Machines</th>
          <th class="px-4 py-3"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let o of owners" class="border-t border-gray-100">
          <td class="px-4 py-3 font-mono text-xs">{{ o.owner_code }}</td>
          <td class="px-4 py-3">{{ o.owner_name }}</td>
          <td class="px-4 py-3">{{ o.owner_type }}</td>
          <td class="px-4 py-3">{{ o.contact_phone || o.contact_email || '—' }}</td>
          <td class="px-4 py-3">{{ o.vendor_company_name || '—' }}</td>
          <td class="px-4 py-3">{{ o.machine_count || 0 }}</td>
          <td class="px-4 py-3 text-right">
            <button mat-button color="primary" type="button" (click)="edit(o)">Edit</button>
          </td>
        </tr>
        <tr *ngIf="!owners.length">
          <td colspan="7" class="px-4 py-8 text-center text-gray-500">No machine owners yet.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
